import { Component, Input } from '@angular/core';
import { FILE_ICON_MAPPINGS } from '@careapp-group/core';

const KNOWN_FILES = [
  'aac',
  'ai',
  'aiff',
  'avi',
  'bmp',
  'css',
  'csv',
  'dat',
  'dmg',
  'doc',
  'dotx',
  'dwg',
  'dxf',
  'eps',
  'exe',
  'flv',
  'gif',
  'html',
  'ics',
  'iso',
  'java',
  'jpg',
  'js',
  'key',
  'mid',
  'mp3',
  'mp4',
  'mpg',
  'odf',
  'ods',
  'odt',
  'otp',
  'ots',
  'ott',
  'pdf',
  'png',
  'ppt',
  'psd',
  'qt',
  'rar',
  'rtf',
  'tga',
  'tgz',
  'tiff',
  'txt',
  'wav',
  'xls',
  'xlsx',
  'xml',
  'yml',
  'zip',
];

@Component({
  selector: 'ca-file-icon',
  templateUrl: './file-icon.component.html',
})
export class FileIconComponent {
  public get mimeType(): string {
    return this._mimeType;
  }

  @Input()
  public set mimeType(value: string) {
    this._mimeType = value;
    this.fileIcon = this.iconForMimeType(value);
  }
  public fileIcon = '_blank';
  private _mimeType: string;

  static iconForMimeType(mimeType: string) {
    const cmp = new FileIconComponent();
    return `assets/images/file-icons/${cmp.iconForMimeType(mimeType)}.png`;
  }

  iconForMimeType(mimeType: string): string {
    if (!mimeType) {
      return '_blank';
    }

    // Brute-force approach. Just try to chop the second half of the mime type and see if it matches
    const sliced = mimeType.slice(mimeType.indexOf('/') + 1);
    if (KNOWN_FILES.indexOf(sliced) >= 0) {
      return KNOWN_FILES[KNOWN_FILES.indexOf(sliced)];
    }

    if (FILE_ICON_MAPPINGS[mimeType]) {
      return FILE_ICON_MAPPINGS[mimeType];
    }

    return '_blank';
  }
}
